import { gridPaths } from '@/shared/hooks';
import { createEntityGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchBuildsGrid } from './gridQuery';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { BuildDto } from '@flowqa/shared';

export const buildsGridConfig = ({
  projectId,
  organisationId,
  fixedFilters,
  initialSortModel = [{ field: 'startedAt', sort: 'desc' }],
  initialFilterModel,
  persistKey,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  syncStateToUrl?: boolean;
} = {}): GridConfig<BuildDto> =>
  createEntityGridConfig<BuildDto>({
    path: gridPaths.builds,
    queryFn: async (input) => await fetchBuildsGrid(projectId, organisationId, input),
    noRowsText: 'No builds found',
    fixedFilters,
    initialSortModel,
    initialFilterModel,
    persistKey,
    defaultPersistKey: 'builds',
    syncStateToUrl,
  });

export type BuildsGridConfig = ReturnType<typeof buildsGridConfig>;
